import {
  FETCH_EWO_DISCRIPENCY_REQUEST,
  FETCH_EWO_DISCRIPENCY_SUCCESS,
  FETCH_EWO_DISCRIPENCY_FAILURE,
} from "../constants/EWODiscripencyConstants";

import EWODiscripencyService from "../service/EWODiscripencyService";

export const fetchEWODiscripency = (date) => async (dispatch) => {
  if (!date) {
    console.error("Date is required");
    return;
  }

  try {
    dispatch({ type: FETCH_EWO_DISCRIPENCY_REQUEST });

    const data = await EWODiscripencyService.getAll(date);

    dispatch({
      type: FETCH_EWO_DISCRIPENCY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EWO_DISCRIPENCY_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
